import  { useState, useRef } from "react";
import classNames from "classnames";

import { LoadingIndicator } from "../../components/utilities/loader";
import { useAuth } from "../../services/authentication/authentication.context";
import { AppAlert } from "../../components/utilities/app-alert";

export const AddAvatar = () => {

    const [avatar, setAvatar] = useState(''); 
    const [preview, setPreview] = useState();
    const [onAlert, setOnAlert] = useState(); 

    const { isLoading, saveUserAvatar, token } = useAuth();

    const changePic = (e) => {
        e.preventDefault();
        const fileType = e.target.files[0]?.type.split("/")[0];
        if (fileType !== "image") {
            alert("Invalid file type! upload an image!");
        }
        setPreview(URL.createObjectURL(e.target.files[0]));
        setAvatar(e.target.files[0]);
    }
    
    const clickRef = useRef();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await saveUserAvatar(avatar,token);
        console.log(res);
        setOnAlert({
            caption: "Success",
            message: res?.message
        })
    }

    return (
        <div className={classNames("flx-cnt-pg", "full-v")}>
            {isLoading && <LoadingIndicator />}
            {onAlert && (
                <AppAlert 
                    caption={onAlert?.caption}
                    message={onAlert?.message}
                    accept={'Ok'}
                    onAccept={() => setOnAlert()}
                    closeAlert={() => setOnAlert()}
                />
            )}
            <div className={classNames("cap","lg-txt")}>Great!</div>
            <div className="sm-sp" />
            <div className={classNames("cap","lg-txt")}>Add a profile picture for yourself</div>
         
            <div className="md-sp" />
            <form className="sign-in" onSubmit={handleSubmit}>
                <div className="avatar-prev">
                    <img src={preview} alt="" width={150} value={avatar} height={150} className="prev-img" />
                </div>
                <button 
                    className="sel-click"
                    onClick={(e) => {
                        e.preventDefault();
                        clickRef.current.click();
                    }}
                >
                    Select a picture
                </button>
                <input 
                    type="file" 
                    name="avatar"  
                    onChange={(e) => changePic(e)}
                    className="file-sel"
                    ref={clickRef}
                />
                <button 
                    className={classNames("form-button",'pill-input-box')}
                >
                    Submit
                </button>
            </form>
        </div>
    )
}